import React from 'react'
import { Typography, Paper, Box, Stack } from '@mui/material'
import { Email, Fax, Language, Person, Phone, Place } from '@mui/icons-material'

interface IContactWorldSellers {
  ImageUrl?: string
  ImageAlt?: string
  bioImagePath?: string
  name?: string
  email?: string
  tollFreePhone?: string
  fax?: string
  Contact?: string
  Email?: string
  PhoneNumber?: string
}

interface IContactUSSeller {
  Contact: string
  PhoneNumber: string
  Fax: string
  Email: string
}

interface IOptionalRow {
  data: IContactWorldSellers | IContactUSSeller
  attributeName: string
  mailto?: boolean
  link?: boolean
  icon?: React.ReactNode
}

const OptionalRow = function (props: IOptionalRow) {
  const { data, attributeName, mailto, link, icon } = props
  const value = data[attributeName as keyof typeof data]
  if (value) {
    return (
      <Stack sx={{ flexDirection: 'row', alignItems: 'center', py: 0.5 }}>
        <Stack sx={{ pr: 1 }}>{icon}</Stack>
        <Box>
          {mailto ? (
            <Typography>
              <a href={`mailto:${value}`}>{value}</a>
            </Typography>
          ) : link ? (
            <Typography>
              <a href={value} target='_blank' rel='noopener noreferrer'>
                {value}
              </a>
            </Typography>
          ) : (
            <Typography variant={attributeName === 'NameCompany' ? 'h6' : 'body1'}>{value}</Typography>
          )}
        </Box>
      </Stack>
    )
  } else {
    return null
  }
}

export default function ContactWorldSellers(props: IContactWorldSellers) {
  let { ImageUrl, ImageAlt } = props
  if (!ImageUrl) {
    ImageUrl = 'https://meteor.stullercloud.com/das/133564264?fmt=smart-alpha&wid=200'
  }
  if (!ImageAlt) {
    ImageAlt = 'Authorized Dealer'
  }
  if (props.bioImagePath) {
    ImageUrl = props.bioImagePath
  }

  const dealerUS = {
    Contact: props.name,
    Email: props.email,
    PhoneNumber: props.tollFreePhone,
    Fax: props.fax
  }

  const dealerUSData = [
    {
      attributeName: 'Contact',
      icon: Person
    },
    {
      attributeName: 'Email',
      icon: Email,
      mailto: true
    },
    {
      attributeName: 'PhoneNumber',
      icon: Phone
    },
    {
      attributeName: 'Fax',
      icon: Fax
    }
  ]

  const dealerData = [
    {
      attributeName: 'Contact',
      icon: Person
    },
    {
      attributeName: 'Email',
      icon: Email,
      mailto: true
    },
    {
      attributeName: 'PhoneNumber',
      icon: Phone
    },
    {
      attributeName: 'Address',
      icon: Place
    },
    {
      attributeName: 'Url',
      icon: Language,
      link: true
    }
  ]

  return (
    <Paper data-cy='contact-container' sx={{ p: 2, maxWidth: { md: 400 }, mb: 4 }}>
      <Box sx={{ m: 'auto' }}>
        <img src={ImageUrl} alt={ImageAlt} width={100} />
      </Box>
      <Box>
        {dealerUS.Email && (
          <>
            {dealerUSData.map((dealer, index) => (
              <OptionalRow
                key={index}
                data={dealerUS as IContactUSSeller}
                attributeName={dealer.attributeName}
                icon={<dealer.icon fontSize='small' />}
                mailto={dealer.mailto}
              />
            ))}
          </>
        )}
        <OptionalRow data={props} attributeName='NameCompany' />
        {dealerData.map((dealer, index) => (
          <OptionalRow
            key={index}
            data={props}
            attributeName={dealer.attributeName}
            icon={<dealer.icon fontSize='small' />}
            mailto={dealer.mailto}
            link={dealer.link}
          />
        ))}
      </Box>
    </Paper>
  )
}
